export const locale = {
    lang: "en-US",
    data: {
        DIALOG: {
            CONFIRM: "OK",
            CANCEL: "CANCEL",
            DESC: "Enter the following sentence to confirm: ",
            CONFIRMATION: "delete permanently",
            KNOW_MORE: "KNOW MORE",
            NO: "NO",
            YES: "YES"
        }
    }
};
